<div class="license-settings setting-page">
  <legend>Security</legend>
  <arm-form (submitForm)="onSubmit()" [disableSubmit]="!canSubmit || !confirmationRouterControl.valid  || !confirmationControl.valid">
    <div class="security-form">
      <div class="form-table-column">
        <div class="security">
          <arm-form-title>Security</arm-form-title>
          <div class="settings-section">
            <mat-form-field class="fullWidth">
              <mat-label>Session timeout (hours)</mat-label>
              <input matInput [(ngModel)]="security.sessionTimeout" type="number" min="1"
                     max="180" name="session-timeout" required>
              <mat-error>
                <strong>Invalid</strong> Session timeout (range: 1 - 180 hours)
              </mat-error>
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Inactivity period (minutes)</mat-label>
              <input matInput [(ngModel)]="security.inactivityPeriod" type="number" min="1"
                     max="10800" name="inactive-period" required>
              <mat-error>
                <strong>Invalid</strong> Inactivity period (range : 1 - 10800 minutes)
              </mat-error>
            </mat-form-field>

            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="security.httpHttpsEnabled"
                            [ngModelOptions]="{standalone: true}"
                            color="primary" name="httpHttpsEnabled">
                HTTPS Only mode (Block incoming HTTP traffic)
              </mat-checkbox>
            </div>

            <div class="security-message">
              <mat-label>* These changes will take effect after logout</mat-label>
            </div>
          </div>
        </div>

        <div class="arm-configuration">
          <arm-form-title>Arm configuration</arm-form-title>
          <div class="settings-section">
            <ac-input-container label="ARM IP Address:">
              <ac-select [acModel]="security.configuratorIpAddress"
                         [searchable]="true"
                         (acModelChange)="security.configuratorIpAddress = $event"
                         [items]="configuratorPossibleIps">
              </ac-select>
            </ac-input-container>

            <mat-form-field class="fullWidth">
              <mat-label>ARM Hostname</mat-label>
              <input matInput [(ngModel)]="security.configuratorHostname" name="configurator-hostname" [required]="!security.isConfCommunicationIpBased">
              <mat-error *ngIf="!security.isConfCommunicationIpBased">
                ARM Hostname is <strong>required</strong> when communication method is hostname based
              </mat-error>
            </mat-form-field>

            <ac-input-container label="Communication method:" class="communication-method">
              <ac-select [acModel]="security.isConfCommunicationIpBased"
                         [searchable]="false"
                         (acModelChange)="security.isConfCommunicationIpBased = $event"
                         [items]="communicationMethodOptions">
              </ac-select>
            </ac-input-container>

            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="security.resolveHostname"
                            [ngModelOptions]="{standalone: true}"
                            color="primary" name="resolveHostname">
                Support underscore in node’s hostname
              </mat-checkbox>
            </div>

          </div>
        </div>
        <div class="certificate-verification">
          <arm-form-title>Certificate verification</arm-form-title>

          <div class="settings-section">
            <div class="arm-checkbox">

            </div>

            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="security.verifyCertificate"
                            [ngModelOptions]="{standalone: true}"
                            color="primary" name="verifyCertificate">
                Verify certificate when ARM performs https requests
              </mat-checkbox>
            </div>

            <div class="arm-checkbox">
              <mat-checkbox [(ngModel)]="security.verifyCertificateSubjectName"
                            [ngModelOptions]="{standalone: true}"
                            color="primary"  name="verifyCertificateSubjectName">
                Verify certificate subject name when ARM performs https requests
              </mat-checkbox>
            </div>

          </div>
        </div>
      </div>
      <div class="form-table-column">
        <div class="ssh">
          <arm-form-title>SSH Users</arm-form-title>
          <div class="settings-section">
            <div class="security-section-title">
              <mat-label>Router SSH Credentials</mat-label>
            </div>
            <mat-form-field class="fullWidth">
              <mat-label>Username</mat-label>
              <input disabled matInput [(ngModel)]="security.sshUsername" name="router-ssh-username">
            </mat-form-field>

            <div [formGroup]="confirmationRouterControl">
              <mat-form-field class="fullWidth">
                <mat-label>Password</mat-label>
                <input type="password" formControlName="password" matInput [(ngModel)]="security.routerSshPassword" name="router-ssh-password"
                        pattern="(?=.*[a-zA-Z].*)(?=.*\d.*)\S{8,20}" autocomplete="new-password">
                <mat-error>Invalid password</mat-error>
              </mat-form-field>

              <mat-form-field class="fullWidth">
                <mat-label>Confirm password</mat-label>
                <input type="password"formControlName="confirm-password"  matInput [(ngModel)]="security.routerSshPasswordConfirm" name="router-confirm-password"  [errorStateMatcher]="matcher">
                <mat-error *ngIf="confirmationRouterControl.errors?.mismatch">Confirm password does not match password</mat-error>
              </mat-form-field>
            </div>
            <div class="security-section-title">
              <mat-label>Configurator SSH Credentials</mat-label>
            </div>
            <mat-form-field class="fullWidth">
              <mat-label>Username</mat-label>
              <input disabled matInput [(ngModel)]="security.sshUsername" name="conf-ssh-username">
            </mat-form-field>

            <div [formGroup]="confirmationControl">
              <mat-form-field class="fullWidth">
                <mat-label>Password</mat-label>
                <input type="password" formControlName="password" matInput [(ngModel)]="security.confSshPassword" name="conf-ssh-password"
                       pattern="(?=.*[a-zA-Z].*)(?=.*\d.*)\S{8,20}" autocomplete="new-password">
                <mat-error>Invalid password</mat-error>
              </mat-form-field>

              <mat-form-field class="fullWidth">
                <mat-label>Confirm password</mat-label>
                <input type="password" formControlName="confirm-password" matInput [(ngModel)]="security.confSshPasswordConfirm" name="conf-ssh-confirm-password" [errorStateMatcher]="matcher">
                <mat-error *ngIf="confirmationControl.errors?.mismatch">Confirm password does not match password</mat-error>
              </mat-form-field>
            </div>

            <div class="password-rules-container">
              <mat-label class="password-rule-item">The password length must be between 8 and 20.</mat-label>
              <mat-label class="password-rule-item">Must contain at least one letter and one digit.</mat-label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </arm-form>
</div>
